// Module
var code = `<span ng-hide="pageState.view"><select ng-options="ct.value as ct.label group by ct.group  for ct in contactTypeEnum" ng-change="addAnotherContactMethod(this)" ng-model="newContactMethod"><option value="">Add Another Contact Method&hellip;</option></select></span>`;
// Exports
export default code;